<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" label-position="top" ref="form" label-width="100px">

            <el-form-item label="语言"  prop="lang" :error="formErrorMsg.lang" class="fb-form-item">
                <dict-select type-flag="LANG" v-model="formData.lang"></dict-select>
            </el-form-item>

            <el-form-item label="User agreement" prop="userAgreement" :error="formErrorMsg.userAgreement" class="fb-form-item">
                <el-input  type="textarea" v-model="formData.userAgreement" placeholder="User agreement"></el-input>
            </el-form-item>

            <el-form-item label="Legal Disclaimer" prop="privacyAgreement" :error="formErrorMsg.privacyAgreement" class="fb-form-item">
                <el-input type="textarea" v-model="formData.privacyAgreement" placeholder="Legal Disclaimer"></el-input>
            </el-form-item>

            <el-form-item label="Application introduction" prop="applicationIntroduction" :error="formErrorMsg.applicationIntroduction" class="fb-form-item">
                <el-input type="textarea" v-model="formData.applicationIntroduction" placeholder="Application introduction"></el-input>
            </el-form-item>




            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>

    export default {
        name: "SysConfig",
        components: {},
        data() {
            return {
                api:{
                    config:this.$api.sysConfig.config,
                    detail:this.$api.sysConfig.detail,
                },
                formErrorMsg:{
                    userAgreement: '',
                    privacyAgreement: '',
                    applicationIntroduction:'',
                },
                formData: {
                    code: '',
                    userAgreement: '',
                    privacyAgreement: '',
                    applicationIntroduction:'',
                    lang:'en'
                },
                rules: {
                    name: [
                    ]
                }
            }
        },
        watch:{
            'formData.lang'(){
                this.loadData();
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.config,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });

                            }else if(resp.data.status === 400){
                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });
                                });
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            },
            loadData(){
                let vm = this;
                this.$http.post(this.api.detail,this.$qs.stringify(Object.assign({lang:this.formData.lang},this.$route.query))).then(function (resp) {
                    for(let key in resp.data.data){
                        for(let fKey in vm.formData){
                            if(fKey !== 'lang'){
                                vm.formData[fKey] = resp.data.data[key][fKey];

                            }
                        }
                    }
                });
            }
        },

        created() {

            this.loadData();

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>


<style>

    .editor-item{
        position: relative;
    }

    .editor-item >.el-form-item__content{
        line-height: initial !important;
    }
</style>